import { render } from "./Index.vue?vue&type=template&id=b62dc6de&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=b62dc6de&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b62dc6de"]])

export default __exports__